export default "__VITE_ASSET__Dyqs$z2v__"